import React from "react";
import {Card} from "../../../../../components/card/card.jsx";
import SentryRow from "../../../../../components/template/sentry-row.jsx";
import SelectComponent from "../../../../../components/select/select-component.jsx";
import InputDatetime from "../../../../../components/input/input-datetime.jsx";
import Button from "../../../../../components/button/button.jsx";
import {FaPlus, FaTrash} from "react-icons/fa";

const DispatchImageReservation = ({
    value,
    onChange,
    cameraRows,
    setCameraRows,
    causeOptions,
    attendanceOptions,
    cameraOptions,
    onAddCamera,
}) => {
    const updateCamera = (tempId, partial) =>
        setCameraRows(prev => prev.map(row => row.tempId === tempId ? {...row, ...partial} : row));

    const removeCamera = (tempId) =>
        setCameraRows(prev => prev.filter(row => row.tempId !== tempId));

    const selectedCause = causeOptions.filter(option => (value.cause ?? []).includes(option.value));
    const selectedAttendance = attendanceOptions.find(option => String(option.value) === String(value.attendanceId)) ?? null;

    return (
        <Card>
            <Card.Header>
                <Card.Title>Reserva de imagem</Card.Title>
            </Card.Header>
            <Card.Body className="flex flex-col gap-4">
                <SentryRow>
                    <SelectComponent
                        classNameWrapper="col-span-5"
                        id="reservation-cause"
                        label="Motivo"
                        isMulti
                        wrapValues
                        options={causeOptions}
                        value={selectedCause}
                        onChange={(options) => onChange({cause: (options ?? []).map(option => option.value)})}
                    />
                    <SelectComponent
                        classNameWrapper="col-span-4"
                        id="reservation-attendanceId"
                        label="Solicitação anterior (protocolo do atendimento)"
                        options={attendanceOptions}
                        value={selectedAttendance}
                        onChange={(option) => onChange({attendanceId: option?.value ?? ""})}
                    />
                    <InputDatetime
                        classNameWrapper="col-span-3"
                        id="reservation-dtFact"
                        label="Data/Hora do fato"
                        dateFormat="LL"
                        returnDateObj={false}
                        selected={value.dtFact}
                        onChange={(dateValue) => onChange({dtFact: dateValue ?? ""})}
                    />
                </SentryRow>

                <div className="overflow-hidden rounded-lg border border-[#D2D3D5] font-[Roboto,sans-serif] text-[#2E3742]">
                    <div className="grid grid-cols-12 gap-2 items-center bg-[#efefef] px-2 h-10 text-sm font-bold border-b border-[#D2D3D5]">
                        <span className="col-span-5">Câmera</span>
                        <span className="col-span-3">Data/Hora inicial da gravação</span>
                        <span className="col-span-3">Data/Hora final da gravação</span>
                        <span className="col-span-1 text-center">Ação</span>
                    </div>

                    {!cameraRows.length &&
                        <div className="px-2 h-7.5 text-center text-sm content-center">Nenhuma câmera.</div>
                    }

                    {cameraRows.map((row, index) => {
                        const cameraValue = cameraOptions.find(option => String(option.value) === String(row.cameraId))
                            ?? (row.cameraId ? {value: row.cameraId, label: row.cameraName} : null);
                        return (
                            <div
                                key={row.tempId}
                                className={["grid grid-cols-12 gap-2 items-center px-2 py-2", index === cameraRows.length - 1 ? "" : "border-b border-[#D2D3D5]"].join(" ")}
                            >
                                <SelectComponent
                                    classNameWrapper="col-span-5"
                                    label=""
                                    options={cameraOptions}
                                    value={cameraValue}
                                    onChange={(option) => updateCamera(row.tempId, {
                                        cameraId: option?.value ?? "",
                                        cameraName: option?.label ?? "",
                                        vmsId: option?.vmsId ?? "",
                                    })}
                                />
                                <InputDatetime
                                    classNameWrapper="col-span-3"
                                    id={`camera-dtstart-${row.tempId}`}
                                    label=""
                                    dateFormat="LL"
                                    returnDateObj={false}
                                    selected={row.dtStart}
                                    onChange={(dateValue) => updateCamera(row.tempId, {dtStart: dateValue ?? ""})}
                                />
                                <InputDatetime
                                    classNameWrapper="col-span-3"
                                    id={`camera-dtend-${row.tempId}`}
                                    label=""
                                    dateFormat="LL"
                                    returnDateObj={false}
                                    selected={row.dtEnd}
                                    onChange={(dateValue) => updateCamera(row.tempId, {dtEnd: dateValue ?? ""})}
                                />
                                <div className="col-span-1 flex justify-center">
                                    <Button type="button" target="danger" title="Remover" onClick={() => removeCamera(row.tempId)}><FaTrash/></Button>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="w-fit">
                    <Button type="button" onClick={onAddCamera}><FaPlus/> Adicionar câmera</Button>
                </div>
            </Card.Body>
        </Card>
    );
};

export default DispatchImageReservation;
